import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, uniqWith, isEqual, filter, reduce, includes, find, get } from 'lodash';
import {
    currencyMapper,
    doesPropExistAndHasItChanged
} from '@nexio/emvio-util-app';
import { connect } from 'react-redux';
import './WidgetSettings.scss';
import { updateSettings } from './widgetSettingsActions';
import { getWidgetSettingsEntity } from './widgetSettingsEntity';
import { getSelectedMerchants } from '../MerchantSelector/merchantSelectorViewState';
import { EmvioSelect } from '@nexio/emvio-form-components';
import * as _ from 'lodash';

export class WidgetSettings extends Component {
    static propTypes = {
        merchants: PropTypes.array,
        onUpdateSettings: PropTypes.func,
        settings: PropTypes.shape({
            currencyId: PropTypes.string,
            currencyCode: PropTypes.string
        })
    };

    constructor(props) {
        super(props);

        this.generateMapper = this.generateMapper.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);

        this.popoverRef = React.createRef();
        this.buttonRef = React.createRef();

        this.state = {
            shouldRenderCurrencySelect: false,
            merchantMapper: {}
        };
    }

    componentDidMount() {
        this.generateMapper(this.props.merchants);
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'merchants')) {
            this.generateMapper(this.props.merchants);
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'settings')) {
            const currencyFilterValue = get(this.props.settings, 'currencyId');
            if (currencyFilterValue) {
                this.setState({ currencyFilter: { value: currencyFilterValue } });
            }
        }
    }

    generateMapper(merchants) {

        const allowedCurrencies = uniqWith(map(merchants, 'currencyId'), isEqual);

        const currenciesInMerchantsWidget = filter(currencyMapper, (currency, index) => {
            currency.id = index;

            return includes(allowedCurrencies, index);
        });

        const merchantMapper = reduce(currenciesInMerchantsWidget, (acc, currencyKey) => {
            acc[currencyKey.id] = currencyKey;

            return acc;
        }, {});

        const currencyKeys = Object.keys(merchantMapper);

        const lastValue = get(this.props, 'settings.currencyId', '840');
        const newValue = find(currencyKeys, (key) => isEqual(key, lastValue)) || currencyKeys[0];
        const shouldRenderCurrencySelect = currencyKeys.length > 1;

        this.setState({ shouldRenderCurrencySelect, merchantMapper, currencyValue: newValue });

        const newSettings = {
            ...this.props.settings,
            currencyId: newValue
        };
        this.props.onUpdateSettings(newSettings);
    }

    handleCurrencyChange (newId) {
        if (this.state.merchantMapper[newId]) {
            const newCurrency = this.state.merchantMapper[newId];

            const settings = {
                ...this.props.settings,
                currencyId: newCurrency.id,
                currencyCode: _.toUpper(newCurrency.code)
            };
            this.props.onUpdateSettings(settings);
        }

    }

    render() {
        const currencyId = get(this.props, 'settings.currencyId', '840');
        const currencyOptions =  _.map(this.state.merchantMapper, (currency, key) => {
            return {
                label: `${_.toUpper(currency.code)} - (${currency.symbol})`,
                value: key
            };
        });
        if (this.state.shouldRenderCurrencySelect){
            return (
                <div className="widget-settings">
                    <EmvioSelect className="currency-selector"
                        label="CURRENCY"
                        options={currencyOptions}
                        onChange={this.handleCurrencyChange}
                        defaultSelectedOption={currencyOptions.find((currencyOptions) => currencyOptions.value === currencyId)}
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        merchants: getSelectedMerchants(state),
        settings: getWidgetSettingsEntity(state)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onUpdateSettings: (settings) => dispatch(updateSettings(settings))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetSettings);
